import React, { useState }  from 'react';

type useInputReturnValue = [
    string,
    React.Dispatch<React.SetStateAction<string>>,
    () => void,
    (event: React.FormEvent<HTMLInputElement>) => void,
];
/**
 * @param  {string} initialValue
 * @returns useInputReturnValue
 */
export const useInput = (initialValue: string): useInputReturnValue => {
    const [value, setValue] = useState<string>(initialValue);
    const resetValue = () => setValue("");
    return [
        value,
        setValue,
        resetValue,
        (event: React.FormEvent<HTMLInputElement>) => {
            setValue(event.currentTarget.value);
        },
    ];
};



// WEBPACK FOOTER //
// ./src/hooks/useInput.ts